import { createContext, useContext } from 'react';

export type AgencyPortalFeatures = {
  allowEmergencyCallNotification: boolean;
};

export type AgencyPortalConfiguration = {
  appName?: string | null;
  themeColor?: string | null;
  logoFolderPath?: string | null;
  agencyPortalFeatures: AgencyPortalFeatures;
};

export type AgencyConfiguration = {
  id: string;
  agencyPortalConfiguration: AgencyPortalConfiguration;
};

export const AgencyConfigurationContext = createContext<AgencyConfiguration | null>(null);

export function useAgencyConfiguration(): AgencyConfiguration | null {
  return useContext(AgencyConfigurationContext);
}
